import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ProtectedCourse from "./ProtectedCourse";
import { accountRequest } from "./accountApi";
import "./AccountPages.css";

export default function AccountShell({ title, children }) {
  return <ProtectedCourse initialMode="login">
    <section className="ltc-member-page">
      <div className="ltc-member-card">
        <nav className="ltc-member-nav" aria-label="Account navigation">
          <Link to="/profile">Profile</Link>
          <Link to="/change-password">Change Password</Link>
        </nav>
        <h1>{title}</h1>
        {children}
      </div>
    </section>
  </ProtectedCourse>;
}

export function useAccountProfile() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError("");
    accountRequest("profile", undefined, controller.signal)
      .then((data) => { if (!controller.signal.aborted) setUser(data.user); })
      .catch((error) => { if (!controller.signal.aborted) setError(error.message); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    const refresh = () => setRevision((value) => value + 1);
    window.addEventListener("ltc-auth-changed", refresh);
    return () => { controller.abort(); window.removeEventListener("ltc-auth-changed", refresh); };
  }, [revision]);
  return { user, setUser, loading, error, retry: () => setRevision((value) => value + 1) };
}

export function PasswordField({ id, label, value, onChange, autoComplete = "new-password", maxLength = 72 }) {
  const [visible, setVisible] = useState(false);
  // Clear visibility after successful submission clears the value.
  useEffect(() => { if (!value) setVisible(false); }, [value]);
  return <div className="ltc-member-field">
    <label htmlFor={id}>{label}</label>
    <div className="ltc-member-password">
      <input id={id} type={visible ? "text" : "password"} required value={value}
        onChange={onChange} autoComplete={autoComplete} maxLength={maxLength} />
      <button type="button" aria-label={visible ? `Hide ${label}` : `Show ${label}`}
        aria-pressed={visible} aria-controls={id} onClick={() => setVisible((value) => !value)}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
          <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
          <circle cx="12" cy="12" r="3" />
          {visible && <path d="m3 3 18 18" />}
        </svg>
      </button>
    </div>
  </div>;
}
